import { render, staticRenderFns } from "./PaxInfo.vue?vue&type=template&id=05a8f94f&"
import script from "./PaxInfo.vue?vue&type=script&lang=ts&"
export * from "./PaxInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports